<script>
export default {
	name: 'MasKargoHomepageLayout',
	expose: [],
	inheritAttrs: false,
};
</script>

<script setup>
import { useGlobalAEMState } from '~/logic/aem/global-aem-state.js';
import ExperienceFragment from '~/aem-components/ExperienceFragment.vue';
import BtnBackToTop from '~/components/BtnBackToTop.vue';
import { generateXfPath } from '@/logic/aem/generate-xf-path';

const rootEl = ref(null);

const { isEditorMode } = useGlobalAEMState();
const siteName = window.siteName;

</script>


<template>
<div ref="rootEl" class="MasKargoHomepageLayout flex flex-col min-h-screen" data-layout="MasKargoHomepage">

	<ExperienceFragment
		class="global-header-notification"
		xfPath="/content/experience-fragments/maskargo/$lang/site/header-notification/master"
	/>
	<div class="sticky-spacer h-$headerNotificationHeight"></div>
	
	<ExperienceFragment
		class="global-header"
		xfPath="/content/experience-fragments/maskargo/$lang/site/header/master"
	/>
	
	<div id="content"></div>
	<main>
		<slot></slot>
	</main>
	
	<div class="floating-bottom-right-container">
		<BtnBackToTop />
	</div>
	
	<ExperienceFragment
		class="global-cookies-notification"
		xfPath="/content/experience-fragments/maskargo/$lang/site/cookies-notification/master"
	/>
	<ExperienceFragment
		class="global-footer"
		xfPath="/content/experience-fragments/maskargo/$lang/site/footer/master"
	/>
</div>
</template>



<style scoped lang="scss">
@use '~/styles/partials/_var.scss';

:slotted(.page) {
	min-height: 400px;
}

</style>
